const state = {
    banking_details: [
        {
            id: "",
            account_name: "",
            account_number: "",
            sort_code: "",
            iban: "",
            bic_swift: "",
        },
    ],
};

const getters = {
    bankingDetailsState: (state) => state.banking_details,
};

const actions = {
    async doGetBankingDetails({ commit, rootState }) {
        let userId = rootState.submissions.submission.id ?? rootState.user.user.id; // Using the submission user ID if we are coming from the Admin panel
        return new Promise((resolve, reject) => {
            axios.get("/user/" + userId + "/details/banking").then(
                (response) => {
                    if (response.data.length) {
                        commit("setBankingDetails", response.data);
                    }
                    resolve(response.data);
                },
                (error) => {
                    console.log(error);
                    reject(error);
                }
            );
        });
    },
    async doUpdateBankingDetails({ commit, rootState }, bankingDetails) {
        let userId = rootState.submissions.submission.id ?? rootState.user.user.id; // Using the submission user ID if we are coming from the Admin panel
        return new Promise((resolve, reject) => {
            if (this.throttle) clearTimeout(this.throttle); // Simple debouncing technique
            this.throttle = setTimeout(() => {
                let bankingDetailsID = bankingDetails.id ? bankingDetails.id : 0;
                axios
                    .patch("/user/" + userId + "/details/banking/" + bankingDetailsID, bankingDetails)
                    .then(
                        (response) => {
                            commit("setBankingDetails", response.data);
                            resolve(response.data);
                        },
                        (error) => {
                            console.log(error);
                            reject(error);
                        }
                    );
            }, 500);
        });
    },
    async doAddAdditionalBankingDetails({ commit }) {
        commit("addAdditionalBankingDetails");
    },
    async doRemoveAdditionalBankingDetails({ commit, rootState, state }, index) {
        let bankingDetailsToRemoveId = state.banking_details[index].id;

        commit("removeAdditionalBankingDetails", index);
        if (bankingDetailsToRemoveId) {
            let userId = rootState.submissions.submission.id ?? rootState.user.user.id; // Using the submission user ID if we are coming from the Admin panel
            return new Promise((resolve, reject) => {
                axios.delete("/user/" + userId + "/details/banking/" + bankingDetailsToRemoveId).then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        console.log(error);
                        reject(error);
                    }
                );
            });
        }
    },
};
const mutations = {
    setBankingDetails: (state, bankingDetails) => {
        state.banking_details = bankingDetails;
    },
    removeAdditionalBankingDetails: (state, index) => {
        console.log("removeAdditionalBankingDetails", index);
        state.banking_details.splice(index, 1);
    },
};
export default {
    state,
    getters,
    actions,
    mutations,
};
